// Maps API eventType string to the display label shown in the UI
const EVENT_TYPE_LABEL: Record<string, string> = {
  EarningsReleases: 'Earnings release',
  EarningsCallsAndPresentations: 'Earnings conference call',
  CorporateCallsAndPresentations: 'Corporate conference call',
  ExDividends: 'Ex-dividend',
  StockSplits: 'Stock split',
  ShareholderAndAnnualMeetings: 'Shareholder / Annual general meeting',
  OtherCorporate: 'Other corporate',
  MAAndMergers: 'M&A announcement',
};

export const getEventTypeLabel = (eventType: string): string =>
  EVENT_TYPE_LABEL[eventType] ?? eventType;

// Two detail panel templates:
// - 'standard'       : Event Type, Event Name, Date, External link
// - 'dividend-split' : + Announce date, Amount/Ratio, Record date, Ex-date, Payout date
type EventDetailTemplate = 'standard' | 'dividend-split';

export const getDetailTemplate = (eventType: string): EventDetailTemplate => {
  if (eventType === 'ExDividends' || eventType === 'StockSplits') {
    return 'dividend-split';
  }
  return 'standard';
};
